'use strict';

var responsiveStyle = require('./responsive-style');
module.exports = responsiveStyle('flex');


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/flex.js
// module id = 658
// module chunks = 3